import cls from './mind-box-banner-container.module.scss'

export const MindBoxBannerContainer = () => {
	return <div className={cls.root} id="PopMechanicPriceBlock" />
}
